export default "__VITE_ASSET__GjJ40ZS0__"